import { FC, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import * as XLSX from "xlsx";
import { isExcelFileByExtension } from "../../../../../../../../modules/filestore/utils/FileUtil";
import FileViewerHTML from "../FileViewerHTML";

const CLASSNAME = "file-viewer-excel";

export type FileViewerExcelProps = {
  blob: Blob | undefined;
  fileExtension: string | undefined;
  fileName: string | undefined;
};

const FileViewerExcel: FC<FileViewerExcelProps> = ({
  blob,
  fileExtension,
  fileName,
}) => {
  const [arrayBuffer, setArrayBuffer] = useState<ArrayBuffer>();
  const [currentTab, setCurrentTab] = useState<string>();

  useEffect(() => {
    if (isExcelFileByExtension(fileExtension)) {
      blob?.arrayBuffer().then(setArrayBuffer);
    }
  }, [blob, fileExtension]);

  const workbook = arrayBuffer
    ? XLSX.read(arrayBuffer, { type: "array" })
    : undefined;

  if (!workbook) {
    return <></>;
  }

  return (
    <div className={CLASSNAME}>
      <Tabs
        activeKey={currentTab}
        onSelect={(newTab) => newTab && setCurrentTab(newTab)}
      >
        {workbook.SheetNames.map((sheetName) => {
          const worksheet = workbook.Sheets[sheetName];
          let htmlContent;
          try {
            htmlContent = XLSX.utils.sheet_to_html(worksheet);
          } catch {
            // do nothing
          }
          return (
            <Tab key={sheetName} eventKey={sheetName} title={sheetName}>
              <FileViewerHTML
                htmlContent={htmlContent}
                errorMessage={`Failed to load sheet ${sheetName} in workbook ${fileName}`}
              />
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};

export default FileViewerExcel;
